import * as React from 'react';
import { cn } from '@/lib/utils';

const GuideAbout = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-about', 'relative flex max-w-full flex-col gap-8 rounded-xl border border-neutral-lightest bg-white px-[clamp(16px,_3.2vw,_40px)] py-10 shadow-[0px_4px_10px_3px_rgba(93,106,134,0.20)]', className)}
    {...props}
  />
));
GuideAbout.displayName = 'GuideAbout';

const GuideAboutHeader = React.forwardRef(({ className, ...props }, ref) => (
  <header
    ref={ref}
    className={cn('c-guide-about-header', 'flex flex-wrap items-center gap-4', className)}
    {...props}
  />
));
GuideAboutHeader.displayName = 'GuideAboutHeader';

const GuideAboutTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn('c-guide-about-title', 'mb-0 grow text-3xl font-bold text-primary-dark', className)}
    {...props}
  />
));
GuideAboutTitle.displayName = 'GuideAboutTitle';

const GuideAboutBody = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-about-body', 'relative flex flex-col gap-10', className)}
    {...props}
  />
));
GuideAboutBody.displayName = 'GuideAboutBody';

const GuideAboutBg = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('c-guide-about-bg', 'absolute bottom-[920px] top-[166px] w-[224px] md:bottom-[580px]', className)}
    {...props}
  />
));
GuideAboutBg.displayName = 'GuideAboutBg';

const GuideAboutLine = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn('c-guide-about-line', 'h-full w-full', className)}
    {...props}
  />
));
GuideAboutLine.displayName = 'GuideAboutLine';

export { GuideAbout, GuideAboutHeader, GuideAboutTitle, GuideAboutBody, GuideAboutBg, GuideAboutLine };
